class Filters {

    constructor() {
        /**
         * General settings
         */
        this.collectionHandle  = FiltersData.filterSettings.collectionHandle;          // Handle della collezione in question
        this.filterUrlPrefix   = 'filters-';                                           // Serve per riconoscere i filtri nel'url
        this.namespace         = 'customFilter';                                       // Serve per avere degli eventi ad-hoc per i filtri
        this.perPage           = parseInt(FiltersData.filterSettings.perPage);         // Indica quanti prodotti mostrare per pagina
        this.originalMaxPages  = parseInt(FiltersData.filterSettings.filterMaxPages);  // Indica il numero totale di pagine della collection/search originale senza l'aggiunta dei prodotti promo
        this.filterMaxPages    = parseInt(FiltersData.filterSettings.filterMaxPages);  // Indica il numero totale di pagine della collection/search
        this.tagsMaxPages      = parseInt(FiltersData.filterSettings.tagsMaxPages);    // Indica il numero totale di pagine per ottonere i filtri
        this.keyValueSeparator = FiltersData.filterSettings.keyValueSeparator;         // Separatore chiave valore nelle tag

        /**
         * Variables
         */
        this.activeFiltersNumber    = 0;             // Numero di filtri attivi
        this.initialFiltersTag      = [];            // Tags
        this.initialFiltersLabelTag = new Object();  // Tag e titoli tag tradotti
        this.initialProducts        = [];
        this.products               = [];
        this.pages                  = [];            // Array contentente le pagine con gli oggetti dei prodotti della collection/search
        this.currentPage            = 1;             // Indica il numero dell'ultima pagina di prodotti caricata in frontend e può prendere il valore ?page=n dell'url nelle collection
        this.pagination             = 1;             // indica il numero di pagina a frontend //TODO: da specificare meglio
        this.sorting                = false;         // Indica il sort attuale
        this.onInit                 = true;          // Indica se l'init è concluso o meno
        this.filteredProducts       = [];            // Array contentente tutti i prodotti attualmente visibili a frontend
        this.pid                    = false;         // Indica l'id dell'ultimo prodotto su cui si è cliccato, così da ritornare allo stesso prodotto in caso di reload
        this.lastProductPrinted     = 0;             // Indica l'indice dell'ultimo prodotto stampato a video

        // Identifica il primo filtro selezionato dall'utente. Il primo filtro selezionato è quello su cui è possibile fare operazioni di 'or' anche se non possibili.
        // Es: se si seleziona 'nero' tra i filtri 'colore', l'utente non potrà filtrare per un altro colore, in quanto solitamente un prodotto ha una sola tipologia di colore.
        this.currentFilterType = false;

        // Esclusiva SJ: il filtro type (category) in SJ deve essere organizzato in livelli, considerando micro e macro category dei prodotti e non solo micro category
        this.filtersCategoryHierarchical = [];

        /**
         * Views
         */
        this.tagsView     = FiltersData.tagsView ? FiltersData.tagsView : 'ajax-tags';              // serve per costruire l'array dei tag
        this.productsView = FiltersData.productsView ? FiltersData.productsView : 'ajax-products';  // serve per costruire l'array dei prodotti

        /**
         * Filters
         */
        this.initialFilters = FiltersData.filterSettings.filters;
        this.filters        = [];
        this.url            = FiltersData.filterSettings.isSearch ? '/search' : FiltersData.filterSettings.url;

        /**
         * Search
         */
        this.q            = FiltersData.filterSettings.q;
        this.productType  = 'product';
        this.articlesType = 'article';
        this.activeClass  = 'active';
        this.articles     = [];

        //TODO: controllare -> this.articlesView = SlamJam.articlesView ? SlamJam.articlesView : 'ajax-articles'; // serve per costruire l'array degli articoli

        this.showProductsSelector             = this.showProductsSelector ? this.showProductsSelector : '.search-show-products';
        this.showArticlesSelector             = this.showArticlesSelector ? this.showArticlesSelector : '.search-show-articles';
        this.articlesListingSelector          = this.articlesListingSelector ? this.articlesListingSelector : '#shop-articles';
        this.articlesListingContainerSelector = this.articlesListingContainerSelector ? this.articlesListingContainerSelector : '.collection-template--articles';
        this.productsListingContainerSelector = this.productsListingContainerSelector ? this.productsListingContainerSelector : '.collection-template--products';

        /**
         * Common HTML selectors
         */

        this.productsListingSelector     = this.productsListingSelector ? this.productsListingSelector : '#shop-products';
        this.loadMoreSelector            = this.loadMoreSelector ? this.loadMoreSelector : '#loadMore';                                                        // '.load-more';
        this.paginationWrapper           = this.paginationWrapper ? this.paginationWrapper : '#pagination .wrapper';
        this.paginationSelector          = this.paginationSelector ? this.paginationSelector : '.pagination .paginate';
        this.loaderSelector              = this.loaderSelector ? this.loaderSelector : '.loading-wrapper';
        this.sortBySelector              = this.sortBySelector ? this.sortBySelector : '#sort-by';
        this.totalProductsSelector       = this.totalProductsSelector ? this.totalProductsSelector : '#total-products';                                        // Selettore per il contatore dei prodotti trovati filtrando '.filter-desktop__container #total-products';
        this.totalProductsSelectorMobile = this.totalProductsSelectorMobile ? this.totalProductsSelectorMobile : '.filter-mobile__container #total-products';  // Selettore per il contatore dei prodotti trovati filtrando
        this.productCardSelector         = this.productCardSelector ? this.productCardSelector : '.product-card';
        this.mobileFilterApplier         = this.mobileFilterApplier ? this.mobileFilterApplier : '[data-filterAction="applyFilters"]';                         // Tasto per applicare i filtri per versione mobile
        this.mobileLimit                 = this.mobileLimit ? this.mobileLimit : 600;                                                                          // Limite oltre il quale siamo in Desktop (o Tablet)

        // selettore del div degli ordinamenti
        this.sorterWrappers = this.filterWrappers ? this.filterWrappers : '#sort-by';
        // selettore di un singolo ordinamento
        this.sortLinkSelector = this.filterLinkSelector ? this.filterLinkSelector : '.sort-option';

        // selettore del div dei filtri
        this.filterWrappers = this.filterWrappers ? this.filterWrappers : '#shop-filters';
        //this.filterWrappersMobile = this.filterWrappersMobile ? this.filterWrappersMobile : '.filter-mobile__container #shop-filters'

        // selettore di un singolo filtro
        this.filterLinkSelector = this.filterLinkSelector ? this.filterLinkSelector : '.filter-option';

        // selettore in cui mostrare i filtri attualmente in uso
        this.currentFiltersSelector      = this.currentFiltersSelector ? this.currentFiltersSelector : '#current-filters'; //'.filter-desktop__container #current-filters';
        this.currentFilterSelectorMobile = this.currentFilterSelectorMobile ? this.currentFilterSelectorMobile : '.filter-mobile__container #current-filters';

        // selettore per il reset dei filtri
        this.clearFiltersSelector = this.clearFiltersSelector ? this.clearFiltersSelector : '#clear-filters';

        // sorting size
        this.sizesRangeClothing = "pippo"; //TODO: controllare -> SlamJam.strings.filters.group.sizes_range_clothing;

        /**
         * Utilities
         */

        Array.prototype.unique = function() {
            let a = this.concat();

            for (let i = 0; i < a.length; i++) {
                for (let j = i + 1; j < a.length; j++) {
                    if (a[i] === a[j])
                        a.splice(j--, 1);
                }
            }

            return a;
        };

        Array.prototype.insert = function ( index, item ) {
            this.splice( index, 0, item );
        };

        /* Verifica se sono in un dispositivo mobile
         * * Se "width" non viene passato prende la larghezza dalle configurazioni dell'oggetto Filtri
         * * Se "useUseAgent" == false controllo solo la width della finestra
         * @param(optional) {number} width
         * @param(optional) {boolean} useUseAgent
         *
         * @return {boolean}
         */
        this.isMobile = function(width=this.mobileLimit, useUseAgent=true) {
            let isMobile         = false;
            let mediaQueryString = "(max-width: " + width +  "px)";
            if (useUseAgent == true) {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.matchMedia(mediaQueryString).matches ) {
                    isMobile = true;
                }
            }
            else if( window.matchMedia(mediaQueryString).matches ) {
                isMobile = true;
            }
            return isMobile;
        }

        this.handleize = function(str) {
            str = str.toLowerCase();

            var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

            // For the old browsers
            for (var i = 0; i < toReplace.length; ++i) {
                str = str.replace(toReplace[i], "");
            }

            str = str.replace(/\W+/g, "-");

            if (str.charAt(str.length - 1) == "-") {
                str = str.replace(/-+\z/, "");
            }

            if (str.charAt(0) == "-") {
                str = str.replace(/\A-+/, "");
            }

            return str
        };

        this.capitalize = function (word) {
            return word[0].toUpperCase() + word.substring(1).toLowerCase();
        };

        this.initEventHandlers();
        this.customInitEventHandlers();
        this.dispatchEvent('onInit');
        this.closeFilters(); //this.toggleFilters();
        this.closeSorter(); //this.toggleSorter();
        this.init();
    }

    init() {
        let $self           = this;
        let promiseTags     = this.getTags();
        let promiseProducts = this.getProducts();
        let promiseArticles = FiltersData.filterSettings.isSearch ? this.getArticles() : [];

        // Quando ho sia tags che prodotti, inizializzo i filtri
        Promise.all([promiseTags, promiseProducts, promiseArticles]).then(function() {
            $self.initFilters();
        });
    }

    dispatchEvent(event, data) {
        data ? window.dispatchEvent(new CustomEvent(this.namespace + '-' + event, {
            detail: data
        })) : window.dispatchEvent(new CustomEvent(this.namespace + '-' + event))
    }

    formatTags() {
        let filterTags = [];
        let formatFilterTags = {};

        for (let i = 0; i < this.initialFiltersTag.length; i++) {
            filterTags = filterTags.concat(this.initialFiltersTag[i]);
        }

        filterTags = filterTags.unique();

        for (let i = 0; i < filterTags.length; i++) {
            let splittedFilterTag = filterTags[i].split(this.keyValueSeparator); // TODO: addons

            // Se la tipologia del tag è tra quelle incluse in quelle da mostrare
            if (this.initialFilters.find(initialFilter => initialFilter.type === splittedFilterTag[0])) {
                if (formatFilterTags[splittedFilterTag[0]]) {
                    formatFilterTags[splittedFilterTag[0]].push({
                        type: splittedFilterTag[0],
                        tag: splittedFilterTag[1],
                        disabled: false
                    });
                } else {
                    formatFilterTags[splittedFilterTag[0]] = [];
                    formatFilterTags[splittedFilterTag[0]].push({
                        type: splittedFilterTag[0],
                        tag: splittedFilterTag[1],
                        disabled: false
                    });
                }
            }
        };

        //TODO: gestione sorting keys
        this.initialFiltersTag = formatFilterTags;
    }

    getTags() {
        let $self = this;

        return new Promise(function(resolve) {
            let callsCount = $self.tagsMaxPages;
            let promises = [];

            const ajaxCall = (url) => {
                return new Promise(function(resolve) {
                    $.get(url).done(function(data) {
                        let COMMENT_PSEUDO_COMMENT_OR_LT_BANG = new RegExp(
                            '<!--[\\s\\S]*?(?:-->)?' +
                            '<!---+>?' // A comment with no body
                            +
                            '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?' +
                            '|<[?][^>]*>?', // A pseudo-comment
                            'g'
                        );

                        data = data.replace(COMMENT_PSEUDO_COMMENT_OR_LT_BANG, '');
                        data = JSON.parse(data);

                        for (let j = 0; j < data.tags.length; j++) {
                            $self.initialFiltersTag.push(data.tags[j]);
                        }

                        data.customer_tags.forEach(tags => $self.initialFiltersLabelTag[tags[0]] = tags[1]);

                        resolve(data);
                    }).fail(function(data) {
                        totalPromiseError.push({
                            response: data
                        });
                        resolve(data);
                    });
                });
            };

            for (var i = 0; i < callsCount; i++) {
                let url = location.origin + $self.url + '?view=' + $self.tagsView + '&page=' + (i + 1) + ($self.q ? ('&q=' + $self.q) : '') + ($self.productType ? '&type=' + $self.productType : '');

                promises.push(ajaxCall(url));
            };

            Promise.all(promises).then(function() {
                $self.formatTags();
                resolve();
            });
        });
    }

    translateTag(tag){
        let translation = this.initialFiltersLabelTag[tag].toLowerCase();
        if(!translation){
            translation = tag;
        }
        if(translation.includes("translation missing")){
            translation = tag;
        }
        return translation;
    }

    getProducts() {
        let $self = this;

        return new Promise(function(resolve) {
            let callsCount = $self.filterMaxPages;
            let promises   = [];

            const ajaxCall = (url) => {
                return new Promise(function(resolve) {
                    $.get(url).done(function(data) {
                        let COMMENT_PSEUDO_COMMENT_OR_LT_BANG = new RegExp(
                            '<!--[\\s\\S]*?(?:-->)?' +
                            '<!---+>?' // A comment with no body
                            +
                            '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?' +
                            '|<[?][^>]*>?', // A pseudo-comment
                            'g'
                        );

                        data = data.replace(COMMENT_PSEUDO_COMMENT_OR_LT_BANG, '');
                        data = JSON.parse(data);

                        if (data.products.length > 0) {
                            let products = data.products;

                            // Trasformo filterData in un array multidimensionale di filtri //TODO: specificare meglio
                            for (let j = 0; j < data.products.length; j++) {
                                let filterDataArray = [];

                                // Incude gestione esclusiva SJ per il filtro 'category' che può essere rimossa per altri progetti
                                if (products[j].filterData) {
                                    let macroCategory = false;
                                    let microCategory = false;

                                    products[j].filterData.map(function(filterTag, index) {
                                        let splittedFilterTag = filterTag.split($self.keyValueSeparator); // TODO: addons

                                        if (filterDataArray[splittedFilterTag[0]]) {
                                            filterDataArray[splittedFilterTag[0]].push($self.handleize(splittedFilterTag[1]));
                                        } else {
                                            filterDataArray[splittedFilterTag[0]] = [];
                                            filterDataArray[splittedFilterTag[0]].push($self.handleize(splittedFilterTag[1]));
                                        }

                                        if (splittedFilterTag[0] == 'micro-category') {
                                            microCategory = splittedFilterTag[1];
                                        } else if (splittedFilterTag[0] == 'macro-category') {
                                            macroCategory = splittedFilterTag[1];

                                        }
                                    });

                                    // Costruisco l'array dei filtri type con due livelli
                                    if (macroCategory && microCategory) {
                                        if ($self.filtersCategoryHierarchical[macroCategory]) {
                                            if (!$self.filtersCategoryHierarchical[macroCategory].includes(microCategory)) {
                                                $self.filtersCategoryHierarchical[macroCategory].push($self.handleize(microCategory));

                                                // Sort dei filtri
                                                $self.filtersCategoryHierarchical[macroCategory] = $self.filtersCategoryHierarchical[macroCategory].sort(function(a, b) {
                                                    let returnValue = 0;
                                                    let textA = a.toUpperCase();
                                                    var textB = b.toUpperCase();

                                                    returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

                                                    return returnValue;
                                                });
                                            }

                                        } else {
                                            $self.filtersCategoryHierarchical[macroCategory] = [];
                                            $self.filtersCategoryHierarchical[macroCategory].push($self.handleize(microCategory));
                                        }
                                    }
                                }

                                products[j].filterData = filterDataArray;
                            }

                            $self.pages[data.page] = products;
                        }

                        resolve(data);
                    }).fail(function(data) {
                        resolve(data);
                    });
                });
            };

            for (let i = 0; i < callsCount; i++) {
                let url = location.origin + $self.url + '?view=' + $self.productsView + '&page=' + (i + 1) + ($self.q ? ('&q=' + $self.q) : '') + ($self.productType ? '&type=' + $self.productType : '');

                promises.push(ajaxCall(url));
            };

            Promise.all(promises).then(function() {
                // Dopo aver fatto tutte le chiamate, creo l'array con tutti i prodotti
                for (let i = 0; i < $self.pages; i++) {
                    $self.products.push($self.pages[i]);
                }
                resolve();
            });
        });
    }

    integratePromo(){
        let $self       = this;
        let pages       = this.pages;    // Le pagine di prodotti
        let products    = this.products  // I prodotti
        let prodottiNew = [];            // Nuovo array di prodotti
        let pagesNew    = [];            // Nuovo array di pagine

        if(products.length > 0){
            prodottiNew = products;
        }
        else{ // PRIMA VOLTA
            // Creo array prodotti di appoggio
            pages.forEach((page) => {
                page.forEach((product) => {
                    prodottiNew.push(product);
                });
            } );
        }

        // MERGE array per inserire i promo
        // (con aggiunta di elementi null per mantenere il corretto indice dei prodotti)
        Object.entries(promo_images).forEach(([position, promo]) => {
            if(promo.collection_owner == this.collectionHandle){ // Solo se le promo fanno parte di questa collezione
                prodottiNew.insert((position - 1), promo);
                prodottiNew.insert(position, null);
            }
        })

        // Rimuovo i prodotti null
        prodottiNew = prodottiNew.filter(function(item, key){
            if(item != null)
            return item;
        });

        let perPageCounter = 0;
        let tempPage       = [];
        let rePage         = 1;
        let reOrder        = 1;

        prodottiNew.forEach((product, index) => {

            // Rinumero e ripagino i prodotti e li metto nel nuovo array di pagine (solo la prima volta)
            if(!products.length > 0){ prodottiNew[index].page  = product.page  = rePage; }
            if(!products.length > 0){ prodottiNew[index].order = product.order = reOrder; }
            perPageCounter = perPageCounter + product.grid_occupation;
            tempPage.push(product);
            reOrder++;

            // Se la pagina e' completa
            if(perPageCounter >= $self.perPage){
                pagesNew.push(tempPage);
                perPageCounter = 0;
                tempPage       = [];

                rePage++;
                reOrder = 1;
            }
        });

        // Se ho ancora una pagina non completa
        if(perPageCounter != 0){
            pagesNew.push(tempPage);
        }

        // Assegno i nuovi oggetti
        this.products       = prodottiNew;
        this.pages          = pagesNew;
        this.filterMaxPages = pagesNew.length;
    }

    removePromo(){

        let prodottiNew = [];  // Nuovo array di prodotti
        prodottiNew = this.products.filter((item, key) => {
            if(item.grid_occupation != 2)
            return item;
        });
        this.products = prodottiNew;

        let pages = this.pages;  // Le pagine di prodotti

        pages.forEach((page, index)=>{
            let temp_page = page.filter((item, key) => {
                if(item.grid_occupation != 2)
                return item;
            });
            pages[index] = temp_page;
        });

    }

    getArticles() {
        let $self = this;

        return new Promise(function(resolve) {
            let promises = [];

            const ajaxCall = (url) => {
                return new Promise(function(resolve) {
                    $.get(url).done(function(data) {
                        $self.articles = data.resources.results.articles ? data.resources.results.articles : [];

                        resolve(data);
                    }).fail(function(data) {
                        totalPromiseError.push({
                            response: data
                        });
                        resolve(data);
                    });
                });
            };

            let url = location.origin + '/search/suggest.json?q=' + $self.q + ($self.articlesType ? '&resources[type]=' + $self.articlesType : '');

            promises.push(ajaxCall(url));

            Promise.all(promises).then(function() {
                resolve();
            });
        });
    }

    /**
     * Filters logic
     */

    /* Inizializza i filtri ed avvia la prima visualizzazione */
    initFilters() {
        let $self = this;

        this.integratePromo();

        let shouldExecuteFilter = false; // Indica se occorre lanciare la funzione per il filtraggio se ci sono filtri nell'url

        // Controllo se trovo nel localStorage il primo filtro selezionato, che ci servirà per ricreare correttamente l'html dei filtri
        if (localStorage.getItem('filterFirst')) {
            if (!localStorage.getItem('filterFirst') || localStorage.getItem('filterFirst') == 'false') {
                this.currentFilterType = false;
            } else {
                this.currentFilterType = localStorage.getItem('filterFirst');
            }
        }

        // Inizializzo l'array dei filtri in cui mantengo i filtri attualmente selezionati
        $self.initialFilters.forEach(function(filter, index) {
            if (filter.type) {
                $self.filters[filter.type] = [];

                // Controllo se ci sono filtri della tipologia corrente nell'url
                if ($self.getUrlParameter($self.filterUrlPrefix + filter.type)) {
                    let urlParams = $self.getUrlParameter($self.filterUrlPrefix + filter.type).split(',');

                    shouldExecuteFilter = true;

                    // Aggiorno l'array dei fltri con i filtri nell'url
                    for (let j = 0; j < urlParams.length; j++) {
                        $self.updateFilterObject(filter.type, urlParams[j]);
                    }
                }

            }
        });

        // Riempio l'array contenente tutti i prodotti della collection/search. Le pagine partono da 1
        for (let i = 1; i < this.pages.length; i++) {
            //this.products = this.products.concat(this.pages[i]);
            //this.initialProducts = this.initialProducts.concat(this.pages[i]);
            this.initialProducts = this.products;
        }

        // Controllo se ci sono sorting nell'url
        if (this.getUrlParameter('custom-sort-by')) {
            // Ordino i prodotti
            this.sorting = this.getUrlParameter('custom-sort-by');
            this.sortProducts();
        } else {
            // sorting iniziali
            this.sorting = "default";
            this.sortProducts();
        }

        if (parseInt(this.getUrlParameter('page')))       this.currentPage = parseInt(this.getUrlParameter('page'));
        if (parseInt(this.getUrlParameter('pagination'))) this.pagination  = parseInt(this.getUrlParameter('pagination'));

        this.sortFilters();
        this.executeFilters();

        // Aggiorno lo stato della pagina
        this.updateResetButton();
        this.updateLoadMoreButton();
        this.updatePaginationSelector();

        this.onInit = false;
        this.dispatchEvent('onInitEnded');
    }

    executeFilters() {
        let $self = this;

        let productToRemove            = [];
        let filteredProductsFilterData = [];

        this.dispatchEvent('onFiltersUpdating');

        this.updateActiveFilterNumber();

        this.fetchPages();

        this.filteredProducts.forEach(function(product, productIndex) {
            let count  = 0;
            let count2 = 0;

            Object.keys($self.filters).map(function(filterType) {
                if ($self.checkFilter(product.filterData, filterType)) {
                    count++;
                }
                count2++; // TODO: specificare meglio
            });

            if (count == count2) {} else {
                // Segno in un array l'indice del prodotto da eliminare
                productToRemove.push(productIndex);
            }
        });

        // Rimuovo i prodotti da eliminare da quelli visibili a frontend
        this.filteredProducts = $self.filteredProducts.filter(function(product, index) {
            return !productToRemove.includes(index);
        });

        // Creo un array contenente // TODO: spiegare
        this.filteredProducts.forEach(function(product, productIndex) {
            Object.keys(product.filterData).map(function(filterType) {
                if (filteredProductsFilterData[filterType]) {
                    filteredProductsFilterData[filterType] = filteredProductsFilterData[filterType].concat(product.filterData[filterType]).unique();
                } else {
                    filteredProductsFilterData[filterType] = [];
                    filteredProductsFilterData[filterType] = filteredProductsFilterData[filterType].concat(product.filterData[filterType]);
                }
            });
        });

        // Controllo se un filtro deve essere disabilitato se porta a un 'Not found'
        if (this.countActiveFilters() > 0) {
            Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
                for (let i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                    if (filteredProductsFilterData[initialFilterType] && (filteredProductsFilterData[initialFilterType].includes($self.handleize($self.initialFiltersTag[initialFilterType][i].tag)) || $self.currentFilterType == initialFilterType)) {
                        $self.initialFiltersTag[initialFilterType][i].disabled = false;
                    } else {
                        $self.initialFiltersTag[initialFilterType][i].disabled = true;
                    }
                }
            });
        } else {
            Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
                for (let i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                    $self.initialFiltersTag[initialFilterType][i].disabled = false;
                }
            });
        }

        this.dispatchEvent('onFiltersUpdated', {
            product: this.filteredProducts,
            filters: this.filters,
            sorting: this.sorting
        });
    }

    checkFilter(tags, type) {
        let $self = this;

        if (!this.filters[type].length > 0) return true;

        for (let i = 0; i < this.filters[type].length; i++) {
            if (tags[type] && tags[type].includes($self.handleize($self.filters[type][i]))) {
                return true;
            }
        }

        return false;
    }

    updateFilterObject(type, name) {
        if (this.filters[type].includes(name)) {
            this.filters[type] = this.filters[type].filter(filterValue => filterValue !== name);
        } else {
            this.filters[type].push(name);
        }

        // Aggiorno currentFilterType
        if ( !( !!this.currentFilterType ) ) {
            this.currentFilterType = type;
            localStorage.setItem('filterFirst', type);
        }
    }

    updateActiveFilterNumber(){
        let $self = this;
        let activeFilterNumber = 0;
        Object.keys(this.filters).forEach(element => activeFilterNumber = activeFilterNumber + $self.filters[element].length );

        this.activeFiltersNumber = activeFilterNumber;
    }

    updateResetButton(){
        let $self               = this;
        let activeFilterNumber  = this.activeFiltersNumber;
        let clearFiltersButtons = document.querySelectorAll(this.clearFiltersSelector);

        if(activeFilterNumber > 0){
            [...clearFiltersButtons].forEach(function(clearFiltersButton){
                clearFiltersButton.classList.add('visible');
                clearFiltersButton.classList.remove('hidden');
            });
        }
        else{
            localStorage.removeItem('filterFirst');
            $self.currentFilterType = false;
            [...clearFiltersButtons].forEach(function(clearFiltersButton){
                clearFiltersButton.classList.remove('visible');
                clearFiltersButton.classList.add('hidden');
            });
        }

    }
    updateLoadMoreButton(){
        let activeFilterNumber = this.activeFiltersNumber;

        if(!activeFilterNumber > 0){
            this.hideLoadMore();
        }
    }
    updatePaginationSelector(){
        let activeFilterNumber = this.activeFiltersNumber;

        if(activeFilterNumber > 0){
            this.hidePagination();
        }
        else{
            this.showPagination();
        }
    }

    // Gestione del click di un filtro
    handleFilterLinkClick(link) {
        if(!link.classList.contains('disabled')){
            let filterType  = link.dataset.filterType  + '';
            let filterValue = link.dataset.filterValue + '';

            // Resetto pagination, currentPage e filteredProducts
            this.currentPage      = 1;
            this.pagination       = 1;
            this.filteredProducts = [];

            // aggiorno l'oggetto dei filtri
            this.updateFilterObject(filterType, filterValue);

            // Aggiorno url
            this.updateQueryParams();

            // Non applicare il click del filtro se siamo in mobile
            if(!this.isMobile() || true){ // bloccato if ed applico sempre i filtri
                this.applyFilters(link);
            }
            else{
                this.printFilters(); // Refresh filter appearence status
            }
        }
    }

    // Apply dei filtri
    applyFilters(link) {

        // Eseguo logica filtri
        this.executeFilters();

        // Aggiorno lo stato della pagina
        this.updateResetButton();
        this.updateLoadMoreButton();
        this.updatePaginationSelector();
    }

    // Click Apply buttons logic
    applyFilterLinkClick(link) {

        // this.applyFilters(link);

        //close filters panel
        this.toggleFilters();
    }

    // Reset dei filtri
    clearFilters() {
        let $self = this;

        // Resetto pagination, currentPage e filteredProducts
        this.currentPage = parseInt(this.getUrlParameter('page')) ? this.currentPage = parseInt(this.getUrlParameter('page')) : 1;
        this.pagination = 1;
        this.filteredProducts = [];
        //localStorage.setItem('filterFirst', false);
        localStorage.removeItem('filterFirst');
        this.currentFilterType = false;

        // Resetto i filtri
        Object.keys(this.filters).map(function(filterType) {
            $self.filters[filterType] = [];
        });

        // Aggiorno url
        this.updateQueryParams();

        // Eseguo logica filtri
        this.executeFilters();

        // Aggiorno lo stato della pagina
        this.updateResetButton();
        this.updateLoadMoreButton();
        this.updatePaginationSelector();
    }

    findInObjectValuesArray(object, value) {
        let found = false;

        Object.keys(object).forEach(function(objectKey) {
            for (let i = 0; i < object[objectKey].length; i++) {
                if (object[objectKey][i] == value) {
                    found = object[objectKey][i];
                    break;
                }
            }
        });

        return found;
    }

    countActiveFilters() {
        let $self = this;

        return Object.keys(this.filters).reduce(function(filter, index) {
            return filter.concat($self.filters[index])
        }, []).length
    };

    fetchPages() {
        // Aggiungo i prodotti //TODO: specificare meglio
      	var temp_current_page = this.currentPage;
        while (temp_current_page <= this.filterMaxPages && this.pages[temp_current_page]) {
            for (let i = 0; i < this.pages[temp_current_page].length; i++) {
                this.filteredProducts.push(this.pages[temp_current_page][i]);
            }

            temp_current_page = temp_current_page + 1;
        }
    }

    checkPid() {
        let pid = this.getUrlParameter('pid');

        if (pid) {
            let productCard = document.querySelectorAll('[data-product-id="' + pid + '"]')[0];

            if (productCard) {
                let coordinate = productCard.getBoundingClientRect();

                setTimeout(() => {
                    window.scrollTo(coordinate.x, coordinate.y);
                }, 1000);
            }
        }
    }

    // Gestione del click su LoadMore
    handleLoadMoreClick(){
        if(this.lastProductPrinted < this.filteredProducts.length){
            this.pagination = this.pagination + 1;
            this.updateQueryParams();
            this.printProductsListing('load-more');
        }
    }

    /**
     * Sort logic
     */
    handleSortByOnChange() {
        let sortByElement = document.querySelector(this.sortBySelector);

        this.sorting = sortByElement.value;

        this.sortProducts();

        // Resetto pagination, currentPage e filteredProducts
        this.currentPage = parseInt(this.getUrlParameter('page')) ? this.currentPage = parseInt(this.getUrlParameter('page')) : 1;
        this.pagination = 1;
        this.filteredProducts = [];

        // Aggiorno url
        this.updateQueryParams();

        this.executeFilters();
    }

    // Gestione del click di una sort option
    handleSorterLinkClick(link) {
        this.sorting = link.dataset.sorterValue + '';

        this.sortProducts();

        // Resetto pagination, currentPage e filteredProducts
        this.currentPage = parseInt(this.getUrlParameter('page')) ? this.currentPage = parseInt(this.getUrlParameter('page')) : 1;
        this.pagination = 1;
        this.filteredProducts = [];

        // Aggiorno url
        this.updateQueryParams();

        this.executeFilters();
    }

    setActiveSortlink(){
        let $self = this;
        let allLinks = document.querySelectorAll($self.sorterWrappers + ' ' + $self.sortLinkSelector);
        [...allLinks].forEach( function(item, index){
            if(item.dataset.sorterValue == $self.sorting){
                item.parentElement.classList.add("selected");
            }
            else{
                item.parentElement.classList.remove("selected");
            }
        } );
    }

    sortFilters() {
        let $self = this;

        Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
            if (initialFilterType == 'case_size') {
                $self.initialFiltersTag[initialFilterType].sort(
                    function(a, b){ // Number sorting
                        return parseFloat(a.tag) - parseFloat(b.tag);
                    }
                );
            }
        });
    }

    sortProducts() {
        this.setActiveSortlink();
        let page = 1;

        this.removePromo();

        if (this.sorting == 'default') {
            //this.products = this.initialProducts;
            this.products.sort(function(a, b) {
                let returnValue = a.page - b.page;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        // Sorting per price asc
        else if (this.sorting == 'price-ascending') {
            this.products.sort(function(a, b) {
                let returnValue = a.price - b.price;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        // Sorting per price desc
        else if (this.sorting == 'price-descending') {
            this.products.sort(function(a, b) {
                let returnValue = b.price - a.price;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        // Sorting per title asc
        else if (this.sorting == 'title-ascending') {
            this.products.sort(function(a, b) {
                let returnValue = 0;
                let textA = a.title.toUpperCase();
                let textB = b.title.toUpperCase();
                returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        // Sorting per title desc
        else if (this.sorting == 'title-descending') {
            this.products.sort(function(a, b) {
                let returnValue = 0;
                let textA = a.title.toUpperCase();
                let textB = b.title.toUpperCase();
                returnValue = (textB < textA) ? -1 : (textB > textA) ? 1 : 0;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        // Sorting per date asc
        else if (this.sorting == 'created-descending') {
            this.products.sort(function(a, b) {
                let returnValue = b.date - a.date;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        // Sorting per date desc
        else if (this.sorting == 'created-ascending') {
            this.products.sort(function(a, b) {
                let returnValue = a.date - b.date;
                if (returnValue == 0) returnValue = a.order - b.order;
                return returnValue;
            });
        }

        this.integratePromo();

        // Dopo aver ordinato i prodotti (da codice) secondo un determinato sorting,
        // creo le pagine per il frontend con i prodotto ordinati

        this.pages = [];
        let currentPageCounter = 0;

        for (let i = 0; i < this.products.length; i++) {
            if (this.pages[page] != null) {
                this.pages[page].push(this.products[i]);
                currentPageCounter = currentPageCounter + this.products[i].grid_occupation;
            }
            else {
                this.pages[page] = [];
                this.pages[page].push(this.products[i]);
                currentPageCounter = currentPageCounter + this.products[i].grid_occupation;
            }

            // Se arrivo //TODO: specificare meglio
            if (currentPageCounter >= this.perPage) {
                currentPageCounter = 0;
                page += 1;
            }
        }
    }

    /**
     * Query params logic
     */

    getUrlParameter(param) {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);

        if (urlParams.get(param)) return urlParams.get(param);

        return false;
    }

    updateQueryParams() {
        let $self = this;

        let urlParams = [];

        // Aggiorno le query params dell'url
        let filtersQueryParams = Object.keys(this.filters).map(function(key) {
            if ($self.filters[key].length > 0) {
                return $self.filterUrlPrefix + key + '=' + $self.filters[key].join(',');
            }
        }).filter(Boolean);

        urlParams = urlParams.concat(filtersQueryParams);

        // Aggiorno la query param della paginazione
        if (this.pagination > 1) {
            urlParams.push('pagination' + '=' + this.pagination);
        }

        if (this.getUrlParameter('page')) {
            urlParams.push('page' + '=' + this.getUrlParameter('page'));
        }

        if (this.pid) {
            urlParams.push('pid' + '=' + this.pid);
        }

        if (this.getUrlParameter('q')) {
            urlParams.push('q' + '=' + this.getUrlParameter('q'));
        }

        if (this.getUrlParameter('type')) {
            urlParams.push('type' + '=' + this.getUrlParameter('type'));
        }

        if (this.sorting) {
            urlParams.push('custom-sort-by' + '=' + this.sorting);
        }

        // Aggiorno query params nell'url
        history.replaceState(null, null, window.location.href.split('?')[0] + '?' + urlParams.join('&'));
    }

    /**
     * Event handler
     */

    initEventHandlers() {
        let $self = this;

        // Quando l'init è concluso
        window.addEventListener(this.namespace + '-' + 'onInitEnded', function(event) {

            if(FiltersData.filterSettings.isSearch){
                $self.printArticlesListing();
            }

            $self.checkPid();
        });

        document.addEventListener('click', function(event) {
            // Evento onClick di un filtro
            if (event.target.matches($self.filterLinkSelector)) {
                event.preventDefault();
                $self.handleFilterLinkClick(event.target);
            }

            // Evento onClick di "Applica" per mobile
            if (event.target.matches($self.mobileFilterApplier)) {
                event.preventDefault();
                $self.applyFilterLinkClick(event.target);
            }

            // CUSTOM D1 -Evento onClick di una sort option
            if (event.target.matches($self.sortLinkSelector)) {
                event.preventDefault();
                $self.handleSorterLinkClick(event.target);
            }

            // CUSTOM D1 -  Evento onClick del pallino di un filtro
            if (event.target.matches($self.filterLinkSelector + '>*')) {
                event.preventDefault();
                $self.handleFilterLinkClick(event.target.parentElement);
            }

            // Evento onClick del load-more
            let loadMoreLink = $self.loadMoreSelector + ' *';
            if (event.target.matches(loadMoreLink)) {
                event.preventDefault();
                $self.handleLoadMoreClick();
            }

            // Evento onClick del clear all filters
            if (event.target.matches($self.clearFiltersSelector)) {
                event.preventDefault();
                $self.clearFilters();
            }
        }, false);

        document.addEventListener('change', function(event) {
            // Evento onChange della select per il sort
            if (event.target.matches($self.sortBySelector)) {
                event.preventDefault();
                $self.handleSortByOnChange();
            }
        }, false);

        document.addEventListener('click', function(event) {
            // Evento onClick switch view search
            if (event.target.matches($self.showProductsSelector)) {
                event.preventDefault();

                let articlesListingContainer = document.querySelector($self.articlesListingContainerSelector);
                let productsListingContainer = document.querySelector($self.productsListingContainerSelector);

                productsListingContainer.classList.add($self.activeClass);
                articlesListingContainer.classList.remove($self.activeClass);
            }
            if (event.target.matches($self.showArticlesSelector)) {
                event.preventDefault();

                let articlesListingContainer = document.querySelector($self.articlesListingContainerSelector);
                let productsListingContainer = document.querySelector($self.productsListingContainerSelector);

                articlesListingContainer.classList.add($self.activeClass);
                productsListingContainer.classList.remove($self.activeClass);
            }

            // CUSTOM D1 CLICK EVENT
            if (event.target.matches('button[data-tracking-category="Filters Toggle"]')) {
                event.preventDefault();
                $self.toggleFilters();
            }
            if (event.target.matches('button[data-tracking-category="Sort By Toggle"]')) {
                event.preventDefault();
                $self.toggleSorter();
            }
            // Mobile close sort
            if (event.target.matches('#sort-by__parent')) {
                event.preventDefault();
                $self.toggleSorter();
            }
            // Mobile close filter
            if (event.target.matches('#shop-filters__parent')) {
                event.preventDefault();
                $self.toggleFilters();
            }

            // CLose filter with click away
            let filter_container = document.querySelector('#shop-filters__parent');
            if(!event.target.matches('button[data-tracking-category="Filters Toggle"]') && // not button to open filters
               !event.target.matches('#shop-filters__parent') && // not div with filters
               !filter_container.contains(event.target) && // not something included in div with filters
               !event.target.matches('.filter-option, .filter-option *')){ // not a filter option
                if($self.isFiltersOpened()){
                    $self.closeFilters();
                    console.log(event.target);
                }
            }
            // CLose sorter with click away
            let sorter_container = document.querySelector('#sort-by__parent');
            if(!event.target.matches('button[data-tracking-category="Sort By Toggle"]') && // not button to open sorter
               !event.target.matches('#sort-by__parent') && // not div with sortings
               !sorter_container.contains(event.target)){ // not something included in div with sortings
                if($self.isSorterOpened()){
                    $self.closeSorter();
                }
            }

            //Close sorter on apply click
            if(event.target.matches("#sort-by .sortApplier")){
                if($self.isSorterOpened()){
                    $self.closeSorter();
                }
            }

        }, false);

        // CUSTOM D1 EVENT (sort e filter positioning)
        document.addEventListener("resize", function(){
            $self.setFilterPosition();
            $self.setSorterPosition();
        }, true);

        // CUSTOM D1 EVENT (sort e filter positioning)
        document.addEventListener("scroll", function(){
            $self.setFilterPosition();
            $self.setSorterPosition();
        }, true);
    }

    /**
     * Custom Events
     */

    customInitEventHandlers() {
        let $self = this;

        window.addEventListener(this.namespace + '-' + 'onInit', function(event) {
            $self.showLoader();
        });

        // Quando l'init è concluso
        window.addEventListener(this.namespace + '-' + 'onInitEnded', function(event) {
            $self.hideLoader();
        });

        window.addEventListener(this.namespace + '-' + 'onFiltersUpdating', function(event) {
            $self.showLoader();
        });

        // Quando devo aggiornare l'html dei filtri e dei prodotti
        window.addEventListener(this.namespace + '-' + 'onFiltersUpdated', function(event) {
            $self.printProductsListing('reset');
            $self.printCurrentFilters();
            $self.printFilters();
            $self.printTotalProducts();
            $self.hideLoader();

            let desktopColumnFilters = document.querySelector('.filter-desktop');

            /*if (typeof(desktopColumnFilters) != 'undefined' && desktopColumnFilters != null) {
                $('.filter-desktop').stick_in_parent({
                    'inner_scrolling': true,
                    'offset_top': 140
                });
            }*/
        });

        // Quando clicco sulla product card  di un prodotto
        document.body.addEventListener('click', function(event) {
            let productCardElements = document.querySelectorAll($self.productCardSelector);

            productCardElements.forEach(function(element, index) {
                if (element.contains(event.target)) {

                    let queryString = window.location.search;
                    let baseUrl = window.location.href.split('?')[0];
                    let urlParams = new URLSearchParams(queryString);

                    // Se trovo l'id del prodotto, lo salvo prima di andare alla scheda prodotto
                    $self.pid = event.target.closest($self.productCardSelector).dataset.productId ? event.target.closest($self.productCardSelector).dataset.productId : false;

                    if ($self.pid) {
                        if (urlParams.has('pid')) {
                            urlParams.delete('pid');
                        }

                        urlParams.append('pid', $self.pid);

                        let newUrl = baseUrl + '?' + urlParams.toString();

                        history.replaceState(null, null, newUrl);
                    }
                }
            });
        }, false);
    }

    /**
     * Customable render function
     */

    printTotalProducts() {
        let totalProductsElement = document.querySelector(this.totalProductsSelector);
        let totalProductsElementMobile = document.querySelector(this.totalProductsSelectorMobile);
        let count = this.filteredProducts.length;  //let count = SlamJam.strings.filters.general.products.replace('$count', this.filteredProducts.length);

        totalProductsElement.innerHTML = count;
        //totalProductsElementMobile.innerHTML = count;
    }

    printProductsListing(printType) {
        // Controllo se ci sono troppi prodotti visualizzati. In caso ci fossero li nascondo
        let shift = (this.filteredProducts.length - (this.perPage * this.pagination) > 0) ? this.filteredProducts.length - (this.perPage * this.pagination) : 0;
        let productListingElement = document.querySelector(this.productsListingSelector);
        let i;

        if (this.filteredProducts.length == 0) {
            // Gestione not found
            productListingElement.innerHTML = '';
            // alert('Not found');
            this.hideLoadMore();
        } else {
            // Se non sto usando il load more resetto l'html del div contenente i prodotti e resetto la variabile in cui mantengo l'indice dell'ultimo prodotto stampato
            if (printType != 'load-more') {
                this.lastProductPrinted = 0;
                productListingElement.innerHTML = '';
            }

            let counterPrintedProducts = 0; /* QUI */
            let neededProducts         = this.perPage * this.pagination; // Prodotti necessari per riempire le pagine richieste
            for (let index = 0; index < this.lastProductPrinted; index++) {
                counterPrintedProducts = counterPrintedProducts + this.filteredProducts[index].grid_occupation;
            }
            // Se i prodotti richiesti sono maggiori del massimo numero di prodotti disponibli filtrati, quello diventa il numero di prodotti richiesti
            if(neededProducts > this.filteredProducts.length){
                neededProducts = this.filteredProducts.length;
            }

            let gtmObj = [];

            // ciclo per aggiungere i prodotti da visualizzare
            for (i = this.lastProductPrinted; counterPrintedProducts < neededProducts; i++){
                // aggiungo il prodotto
                if (this.activeFiltersNumber != 0) {
                  productListingElement.innerHTML += this.filteredProducts[i].html; // ECCEZIONE
                  /* GTM VISIONE PRODOTTO */
                  //console.warn("IMPRESSION");
                  //console.warn(element);
                  if(this.filteredProducts[i].id){
                      let element = this.filteredProducts[i];
                      /* OLD
                      gtmObj.push({
                        'name'    : element.title,                      //'Ultra Thin Bracelet 40 mm - Creepy Chic',
                        'id'      : element.sku,                        //'D1-UTBJ17',
                        'price'   : (element.price / 100).toFixed(2),   //'395.00',
                        'brand'   : element.vendor,                     //'D1 Milano',
                        'category': element.type,                       //'Watch',
                        'variant' : element.title.split("-")[1]         //'Creepy Chic'
                      }); */
                      gtmObj.push({ /* BT-1712 */
                        'item_name'     : element.orig_title,                        //'Ultra Thin Bracelet 40 mm - Creepy Chic'
                        'item_id'       : element.sku,                               //'D1-UTBJ17'
                        'price'         : (element.price / 100).toFixed(2),          //'395.00'
                        'item_brand'    : element.vendor,                            //'D1 Milano'
                        'item_category' : element.type,                              //'Watch',
                        'item_category2': element.orig_title.split("-")[0].trim(),   //le categorie secondarie del prodotto (es.Polycarbon)
                        'item_category3': element.gender,                            //le categorie secondarie del prodotto (es.Man)
                        'item_variant'  : element.orig_title.split("-")[1],          //'Creepy Chic'
                      });
                  }
                }
                // conto i prodotti aggiunti in base alla loro occupazione di griglia
                counterPrintedProducts = counterPrintedProducts + this.filteredProducts[i].grid_occupation;
            }

            if (this.activeFiltersNumber == 0) {
              this.pages[this.currentPage].forEach(element => {
                  productListingElement.innerHTML += element.html;
                  /* GTM VISIONE PRODOTTO */
                  //console.warn("IMPRESSION");
                  //console.warn(element);
                  if(element.id){
                    /* OLD
                    gtmObj.push({
                        'name'    : element.title,                      //'Ultra Thin Bracelet 40 mm - Creepy Chic',
                        'id'      : element.sku,                        //'D1-UTBJ17',
                        'price'   : (element.price / 100).toFixed(2),   //'395.00',
                        'brand'   : element.vendor,                     //'D1 Milano',
                        'category': element.type,                       //'Watch',
                        'variant' : element.title.split("-")[1]         //'Creepy Chic'
                    }); */
                    gtmObj.push({ /* BT-1712 */
                        'item_name'     : element.orig_title,                        //'Ultra Thin Bracelet 40 mm - Creepy Chic'
                        'item_id'       : element.sku,                               //'D1-UTBJ17'
                        'price'         : (element.price / 100).toFixed(2),          //'395.00'
                        'item_brand'    : element.vendor,                            //'D1 Milano'
                        'item_category' : element.type,                              //'Watch',
                        'item_category2': element.orig_title.split("-")[0].trim(),   //le categorie secondarie del prodotto (es.Polycarbon)
                        'item_category3': element.gender,                            //le categorie secondarie del prodotto (es.Man)
                        'item_variant'  : element.orig_title.split("-")[1],          //'Creepy Chic'
                    });
                  }
              });
            }

            if(typeof GTM !== 'undefined' && GTM != null) {
                GTM.pushPLP(gtmObj);
            }

            // Salvo indice dell'ultimo prodotto stampato
            this.lastProductPrinted = i;

            // Se sono arrivato all'ultima pagina, nascondo il load-more
            // TODO: rivedere il coteggio con l'occupazione di griglia
            if (this.filteredProducts.length == this.filteredProducts.length - shift) {
                this.hideLoadMore();
            } else {
                this.showLoadMore();
            }
            Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);

        }
    }

    printArticlesListing() {
        let $self = this;

        let articlesMarkup = '<div class="search-articles">';

        this.articlesListing = document.querySelector(this.articlesListingSelector);

        for (let i = 0; i < this.articles.length; i++) {
            articlesMarkup +=
            `<div class="search-articles__item">
                <a href="${this.articles[i].url}">
                    <div class="search-articles__title">${this.articles[i].title}</div>
                    <div class="search-articles__description">${this.articles[i].summary_html}</div>
                </a>
            `;
        }

        articlesMarkup += `</div>`;

        this.articlesListing.innerHTML = articlesMarkup;
    }

    printCurrentFilters() {
        let $self = this;
        let currentFiltersElement;

        //if (SlamJam.isMobile(768)) {
          //  currentFiltersElement = document.querySelector(this.currentFilterSelectorMobile);
        //} else {
            currentFiltersElement = document.querySelector(this.currentFiltersSelector);
        //}

        currentFiltersElement.innerHTML = '';

        if (this.countActiveFilters() > 0) {
            let currentFiltersMarkup = '';

            Object.keys(this.filters).map(function(filterType) {
                for (let j = 0; j < $self.filters[filterType].length; j++) {
                    currentFiltersMarkup = currentFiltersMarkup + `<li class="filter-option" data-filter-type="${filterType}" data-filter-value="${$self.filters[filterType][j]}" >` +
                        `${$self.filters[filterType][j]}</li>`;
                }
            });

            let clearFiltersMarkup = `<div class="current-filters__container">
                <div class="current-filters__bar">
                    <div class="current-filters__selected">SELECTED</div>
                    <div class="current-filters__reset"><a id="clear-filters" href="javascript:void(0)">RESET</a></div>
                </div>
                <ul>${currentFiltersMarkup}</ul>
            </div>`;

            let literalTemplate = clearFiltersMarkup;

            currentFiltersElement.innerHTML = literalTemplate;
        }
    }

    printFilters() {
        let $self                          = this,
            filterWrapperElement           = document.querySelector(this.filterWrappers),
            filterWrapperElementMarkup     = '';

        filterWrapperElementMarkup += '<div class="sc-jWBwVP fDrbnp sc-cvbbAY kohcOT">';

        Object.keys(this.initialFiltersTag).map(function(initialFilterType) {
            let type  = $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).type;
            let label = $self.initialFilters.find(initialFilter => initialFilter.type == initialFilterType).label;

            filterWrapperElementMarkup += '<div class="sc-eHgmQL jEmwsk">';
                filterWrapperElementMarkup += '<p class="sc-hMqMXs ewjEin">' + $self.translateTag(type) + '</p>';
                filterWrapperElementMarkup += '<div class="sc-kEYyzF djxYlL">';
                    filterWrapperElementMarkup += '<div class="sc-kkGfuU iTnMYH">';
                    if ($self.initialFiltersTag[initialFilterType].length > 0) {
                        for (let i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                            if(i == 5 || i == 10 || i == 15){
                                filterWrapperElementMarkup += '</div><div class="sc-kkGfuU iTnMYH">';
                            }
                            filterWrapperElementMarkup += '<div ';
                                filterWrapperElementMarkup += 'class="';
                                    filterWrapperElementMarkup += 'filter-option ' + $self.handleize($self.initialFiltersTag[initialFilterType][i].tag) +  ' sc-hSdWYo bNxatt ';
                                    filterWrapperElementMarkup += $self.findInObjectValuesArray($self.filters, $self.handleize($self.initialFiltersTag[initialFilterType][i].tag)) ? 'active ' : '';
                                    filterWrapperElementMarkup += $self.initialFiltersTag[initialFilterType][i].disabled ? 'disabled ' : ' ';
                                filterWrapperElementMarkup += '" ';
                                filterWrapperElementMarkup += 'data-tracking-category="Filter - ' + label + '" ';
                                filterWrapperElementMarkup += 'data-tracking-action="Click" ';
                                filterWrapperElementMarkup += 'data-tracking-label="' + $self.initialFiltersTag[initialFilterType][i].tag + '" ';
                                filterWrapperElementMarkup += 'data-filter-value="'   + $self.handleize($self.initialFiltersTag[initialFilterType][i].tag) + '" ';
                                filterWrapperElementMarkup += 'data-filter-type="'    + initialFilterType + '" ';
                            filterWrapperElementMarkup += '>';

                                filterWrapperElementMarkup += '<span color="#eee" class="sc-iAyFgw bvProU"></span>';
                                filterWrapperElementMarkup += $self.capitalize( $self.translateTag($self.initialFiltersTag[initialFilterType][i].tag) );
                            filterWrapperElementMarkup += '</div>';
                        }
                    }
                    filterWrapperElementMarkup += '</div>';
                filterWrapperElementMarkup += '</div>';
            filterWrapperElementMarkup += '</div>';
        });
        filterWrapperElementMarkup += '<div class="filtersApplier disabled" data-filterAction="applyFilters">' + 'APPLY' + '</div>';
        filterWrapperElementMarkup += '</div>';

        filterWrapperElement.innerHTML = '';                          // Pulisco l'elenco dei prodotti
        filterWrapperElement.innerHTML = filterWrapperElementMarkup;  // Inserisco i prodotti creati
        this.updatePagination();                                      // Aggiorno la paginazione al cambio ordinamento/filtri
    }

    hideLoadMore() {
        let loadMoreElements = document.querySelectorAll(this.loadMoreSelector);

        [...loadMoreElements].forEach(function(loadMoreElement){
            loadMoreElement.style.display = 'none';
        });
    }

    showLoadMore() {
        let loadMoreElements = document.querySelectorAll(this.loadMoreSelector);

        [...loadMoreElements].forEach(function(loadMoreElement){
            loadMoreElement.style.display = 'flex';
        });
    }

    hidePagination() {
        let paginationWrappers = document.querySelectorAll(this.paginationWrapper);

        [...paginationWrappers].forEach(function(paginationWrapper){
            paginationWrapper.style.display = 'none';
        });
    }

    showPagination() {
        this.updatePagination();
        if(this.originalMaxPages == this.filterMaxPages){
            //console.log("OK PAGINAZIONE ORIGINALE");
        }
        else{
            //console.log("TOCCA RIDISEGNA DA CAPO LA PAGINAZIONE");
        }
        let paginationWrappers = document.querySelectorAll(this.paginationWrapper);

        [...paginationWrappers].forEach(function(paginationWrapper){
            paginationWrapper.style.display = 'flex';
        });
    }

    hideLoader() {
        $('body').trigger('hide-loading', {
            handle: 'generic-loading'
        });

        //TODO: gestione migliore
        //loaderElement.style.display = 'none';
    }

    showLoader() {
        $('body').trigger('show-loading', {
            handle: 'generic-loading'
        });

        //TODO: gestione migliore
        //loaderElement.style.display = 'flex';
    }

    // Custom D1 functions
    /* Filters Container functions */
    toggleFilters() {
        // Close Sorter!
        this.closeSorter();

        // Then toggle Filters
        if(this.isFiltersClosed()){
            this.openFilters();
        }
        else{
            this.closeFilters();
        }
    }
    isFiltersClosed() {
        let filterWrapperElement = document.querySelector(this.filterWrappers);
        return filterWrapperElement.classList.contains('hidden');
    }
    isFiltersOpened() {
        let filterWrapperElement = document.querySelector(this.filterWrappers);
        return !filterWrapperElement.classList.contains('hidden');
    }
    openFilters() {
        let filterWrapperElement = document.querySelector(this.filterWrappers);
        filterWrapperElement.classList.add('visible');
        filterWrapperElement.classList.remove('hidden');
        if(this.isMobile()){
            filterWrapperElement.parentElement.classList.add('visible');
            this.blockScroll();
        }
        this.setFilterPosition();
    }
    closeFilters() {
        let filterWrapperElement = document.querySelector(this.filterWrappers);
        filterWrapperElement.classList.remove('visible');
        filterWrapperElement.classList.add('hidden');
        if(this.isMobile()){
            filterWrapperElement.parentElement.classList.remove('visible');
            this.activeScroll();
        }
    }
    setFilterPosition() {
        let filterWrapperElement = document.querySelector(this.filterWrappers);

        if(!this.isMobile()){
            if(filterWrapperElement.classList.contains('visible')){
                let buttonElement                   = document.querySelector('button[data-tracking-category="Filters Toggle"]');
                let viewportOffset                  = buttonElement.getBoundingClientRect();
                    filterWrapperElement.style.top  = (viewportOffset.top  + 50)  + "px"; // TODO: altezza del bottone
                    filterWrapperElement.style.left = (viewportOffset.left + 130) + "px"; // TODO: larghezza del bottone
            }
        }
        else{
            filterWrapperElement.style.top  = "0px";
            filterWrapperElement.style.left = "0px";
        }
    }
    /* Sorter Container functions */
    toggleSorter() {
        // Close Filter!
        this.closeFilters();

        // Then toggle Sorter
        if(this.isSorterClosed()){
            this.openSorter();
        }
        else{
            this.closeSorter();
        }
    }
    isSorterClosed() {
        let sorterWrapperElement = document.querySelector(this.sorterWrappers);
        return sorterWrapperElement.classList.contains('hidden');
    }
    isSorterOpened() {
        let sorterWrapperElement = document.querySelector(this.sorterWrappers);
        return !sorterWrapperElement.classList.contains('hidden');
    }
    openSorter() {
        let sorterWrapperElement = document.querySelector(this.sorterWrappers);
        sorterWrapperElement.classList.add('visible');
        sorterWrapperElement.classList.remove('hidden');
        if(this.isMobile()){
            sorterWrapperElement.parentElement.classList.add('visible');
            this.blockScroll();
        }
        this.setSorterPosition();
    }
    closeSorter() {
        let sorterWrapperElement = document.querySelector(this.sorterWrappers);
        sorterWrapperElement.classList.remove('visible');
        sorterWrapperElement.classList.add('hidden');
        if(this.isMobile()){
            sorterWrapperElement.parentElement.classList.remove('visible');
            this.activeScroll();
        }
    }
    setSorterPosition() {
        let sorterWrapperElement = document.querySelector(this.sorterWrappers);

        if(!this.isMobile()){
            if(sorterWrapperElement.classList.contains('visible')){
                let buttonElement                   = document.querySelector('button[data-tracking-category="Sort By Toggle"]');
                let viewportOffset                  = buttonElement.getBoundingClientRect();
                    sorterWrapperElement.style.top  = (viewportOffset.top  + 50) + "px"; // TODO: altezza del bottone
                    sorterWrapperElement.style.left = (viewportOffset.left + 0)  + "px";
            }
        }
        else{
            sorterWrapperElement.style.top  = "0px";
            sorterWrapperElement.style.left = "0px";
        }
    }
    //blocca scroll della pagina all'apertura dei filters o del sort
    blockScroll(){
        if(!document.querySelector("body").classList.contains("noscroll")){
            document.querySelector("body").classList.add("noscroll");
        }
    }
    //riattiva scroll pagina alla chiusura
    activeScroll(){
        if(document.querySelector("body").classList.contains("noscroll")){
            document.querySelector("body").classList.remove("noscroll");
        }
    }

    updatePagination(){

        const paginationWrapper = document.querySelector(this.paginationWrapper);
        var ul = null;

        if(paginationWrapper){

            if(this.getUrlParameter('page')){
                this.requestedPage = parseInt(this.getUrlParameter('page'));
            }
            else{
                this.requestedPage = 1;
            }
            let actualPage  = this.requestedPage;                 // Pagina attuale
            let pageNumbers = (this.pages.length - 1);            // Numero totale di pagine
            let baseUrl     = window.location.pathname;           // prendo base url
            let baseParams  = window.location.search;             // prendo params attivi da replicare

            var urlParams = new URLSearchParams(baseParams);
            urlParams.delete('page'); // elimino il parametro della pagina se presente

            /* INIZIO CREAZIONE PAGINATION */
            ul = document.createElement('ul');
            //ul.setAttribute('class', 'pagination__list list-unstyled');
            //ul.setAttribute('role', 'list');
            let currentTime = new Date().getTime();
            const d = new Date(currentTime);
            ul.setAttribute('data-tomeRefresh', d.toLocaleTimeString());

            /* Pagina attuale */
            if(pageNumbers > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    a.setAttribute('onclick','return false;');
                    a.setAttribute('class','disabled active');
                    a.setAttribute('title','page ' + actualPage);
                    a.innerHTML = actualPage;
                li.append(a);
                ul.append(li);
            }

            /* Pagina attuale - 1 */
            if(actualPage > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page ' + (actualPage - 1));
                    urlParams.append('page', (actualPage - 1));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = (actualPage - 1);
                li.append(a);
                ul.prepend(li);
            }

            /* Pagina attuale - 2 */
            if(actualPage > 2){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page ' + (actualPage - 2));
                    urlParams.append('page', (actualPage - 2));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = (actualPage - 2);
                li.append(a);
                ul.prepend(li);
            }

            /* Puntini */
            /* Primo */
            if(actualPage > 4){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    a.setAttribute('onclick','return false;');
                    a.setAttribute('title','other pages');
                    a.setAttribute('class','disabled');
                    a.innerHTML = "...";
                li.append(a);
                ul.prepend(li);
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page 1');
                    urlParams.append('page', 1);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = "1";
                li.append(a);
                ul.prepend(li);
            }

            /* Primo */
            if(actualPage == 4){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page 1');
                    urlParams.append('page', 1);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = "1";
                li.append(a);
                ul.prepend(li);
            }

            /* Prev */
                if(pageNumbers > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    a.setAttribute('title','prev');
                    if(actualPage != 1){
                        a.setAttribute('class','prev paginate');
                        urlParams.append('page', (actualPage - 1));
                        a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                        urlParams.delete('page');
                    }
                    else{
                        a.setAttribute('onclick','return false;');
                        a.setAttribute('class','prev disabled');
                        a.setAttribute('href', "#" );
                    }
                        var span = document.createElement('span');
                        span.setAttribute('class','icon__fallback-text');
                        span.innerHTML = D1.strings.collection.prev;
                a.append(span);
                li.append(a);
                ul.prepend(li);
            }

            /* Pagina attuale + 1 */
            if((pageNumbers - actualPage) > 0){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page ' + (actualPage + 1));
                    urlParams.append('page', (actualPage + 1));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = (actualPage + 1);
                li.append(a);
                ul.append(li);
            }

            /* Pagina attuale + 2 */
            if((pageNumbers - actualPage) > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page ' + (actualPage + 2));
                    urlParams.append('page', (actualPage + 2));
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = (actualPage + 2);
                li.append(a);
                ul.append(li);
            }

            /* Puntini */
            /* Ultimo */
            if((pageNumbers - actualPage) > 3){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    a.setAttribute('onclick','return false;');
                    a.setAttribute('title','other pages');
                    a.setAttribute('class','disabled');
                    a.innerHTML = "...";
                li.append(a);
                ul.append(li);
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page ' + pageNumbers);
                    urlParams.append('page', pageNumbers);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = pageNumbers;
                li.append(a);
                ul.append(li);
            }

            /* Ultimo */
            if((pageNumbers - actualPage) == 3){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    //a.setAttribute('onclick','return false;');
                    a.setAttribute('title','page ' + pageNumbers);
                    urlParams.append('page', pageNumbers);
                    a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                    urlParams.delete('page');
                    a.setAttribute('class','paginate');
                    a.innerHTML = pageNumbers;
                li.append(a);
                ul.append(li);
            }

            /* Next */
            if(pageNumbers > 1){
                var li = document.createElement('li');
                    var a = document.createElement('a');
                    a.setAttribute('title','next');
                    if(pageNumbers > actualPage){
                        a.setAttribute('class','next paginate');
                        urlParams.append('page', (actualPage + 1));
                        a.setAttribute('href', baseUrl + '?' + urlParams.toString() );
                        urlParams.delete('page');
                    }
                    else{
                        a.setAttribute('onclick','return false;');
                        a.setAttribute('class','next disabled');
                        a.setAttribute('href', "#" );
                    }
                        var span = document.createElement('span');
                        span.setAttribute('class','icon__fallback-text');
                        span.innerHTML = D1.strings.collection.next;
                a.append(span);
                li.append(a);
                ul.append(li);

                paginationWrapper.innerHTML = '';
                paginationWrapper.append(ul);
            }
        }

    }

}

var filtri = new Filters;
